import { Box } from '@mui/material';
import React from 'react';
export const TabPanel = (props) => {
    if (props.value === props.index) {
        return (React.createElement(Box, { sx: { height: '100%' }, p: 0 }, props.children));
    }
    else {
        return null;
    }
};
